import { render, staticRenderFns } from "./CommodityBrandSaleList.vue?vue&type=template&id=0621fd53&scoped=true"
import script from "./CommodityBrandSaleList.vue?vue&type=script&lang=js"
export * from "./CommodityBrandSaleList.vue?vue&type=script&lang=js"
import style0 from "./CommodityBrandSaleList.vue?vue&type=style&index=0&id=0621fd53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0621fd53",
  null
  
)

export default component.exports